// ABOUTME: The invoice figures panel: what a period was invoiced, beside that revenue over time.
// ABOUTME: Takes an optional relationId, so the same panel serves the overview and one relation.

import { useTranslation } from "react-i18next";
import EuroIcon from '@mui/icons-material/Euro';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

import ShTotalsPanel from "../../theme/cards/ShTotalsPanel";
import { useGetInvoiceDashboardRevenueQuery, useGetInvoiceDashboardTotalsQuery } from "../../../newapi/dashboard/dashboardSlice";

const InvoiceTotalsPanel = ({ relationId }) => {
    const { t } = useTranslation();

    return (
        <ShTotalsPanel
            useTotals={useGetInvoiceDashboardTotalsQuery}
            useChart={useGetInvoiceDashboardRevenueQuery}
            filter={relationId ? { relationId } : undefined}
            chartSubtitles={{
                month: t("revenue_per_month"),
                week: t("revenue_per_week")
            }}
            chartSeries={[
                { type: "currency" },
                { type: "number", chartType: "hidden" },
            ]}
            cards={[
                { key: "totalRevenue", label: t("revenue"), icon: <EuroIcon className="logo"/>, color: "orange", type: "currency" },
                { key: "avgRevenue", label: t("avg_revenue"), icon: <TrendingUpIcon className="logo"/>, color: "purple", type: "currency" },
                { key: "invoiceCount", label: t("invoices"), icon: <ReceiptLongIcon className="logo"/>, color: "blue", type: "number" },
                { key: "orderCount", label: t("orders_shipped"), icon: <LocalShippingIcon className="logo"/>, color: "green", type: "number" },
            ]}
        />
    );
};

export default InvoiceTotalsPanel;
